import { useEffect, useState } from 'react';

export const useTbodyPosition = ({ bodyRef, count, bodyHeight = '300px' }) => {
  const [position, setPosition] = useState({
    x: '50%',
    y: '50%',
  });

  useEffect(() => {
    if (!count && bodyRef?.current) {
      bodyRef.current.style.height = bodyHeight;
    } else if (bodyRef?.current) {
      bodyRef.current.style.height = 'auto';
    }

    const rect = bodyRef?.current?.getBoundingClientRect();
    if (rect) {
      if (rect.left > 20) {
        setPosition((prev) => ({ ...prev, x: `calc(50% + ${rect.left - 122}px)` }));
      }

      if (rect?.top + rect?.height > window?.innerHeight) {
        setPosition((prev) => ({ ...prev, y: '50%' }));
      } else {
        const compute = (rect?.top + rect?.height) / 2;
        const max = Math.max(compute, rect?.top);
        setPosition((prev) => ({ ...prev, y: `${max}px` }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bodyRef, count]);

  return position;
};
